module.exports = __webpack_public_path__ + "static/livesync_mosaic_video-214079d735ffecb57ccf2ec1ebae4bc3.png";